import React from 'react';
import PropTypes from 'prop-types';

const ProductTotalPrice = ({ currency, totalProductPrices, totalLabel }) => (
  <span>
    {totalLabel}{' '}
    <span className="value">
      {' '}
      {currency}
      {totalProductPrices}
    </span>
  </span>
);

ProductTotalPrice.propTypes = {
  currency: PropTypes.string,
  totalProductPrices: PropTypes.string,
  totalLabel: PropTypes.string,
};

export default ProductTotalPrice;
